import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.dashboard.widget.TimelineWidgetModal.';
  public static readonly closeButton = `${Id.prefix}closeButton`;
  public static readonly widgetInfoParagraph = `${Id.prefix}widgetInfoParagraph`;
  public static readonly filterLabel = `${Id.prefix}filterLabel`;
}

export class LangTimelineWidgetModal {
  private constructor() {}

  public static closeButton(): string {
    return interpolate(Id.closeButton);
  }

  public static widgetInfoParagraph(): string {
    return interpolate(Id.widgetInfoParagraph);
  }

  public static filterLabel(): string {
    return interpolate(Id.filterLabel);
  }
}

export class TimelineWidgetModalModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.closeButton, 'Close', 'Button label to close the timeline widget modal');
    register.add(
      Id.widgetInfoParagraph,
      "Information displayed on this widget are attributed to Current UTC, Time Zone (Coordinated Universal Time).\n\nThe values presented are the Dealer's Net Sell Price to the end customer.",
      'Paragraph explaining the information and time zone context for the timeline widget modal'
    );
    register.add(Id.filterLabel, 'Filter: ', 'Label for filter section in timeline widget modal');
  }
}
